import { playerMobileHeight } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
    videoWrapper: {
        position: 'relative',
        height: '0',
        paddingBottom: `${playerMobileHeight}%` /* Aspect ratio 16:9*/,
    },
    previewEndedWall: {
        overflow: 'hidden',
        position: 'relative',
        pointerEvents: 'none',

        '&::before, &::after': {
            display: 'inline-block',
            fontFamily: 'NotoSans',
            fontStretch: 'normal',
            fontStyle: 'normal',
            color: '#ffffff',
            position: 'absolute',
            right: '50%',
            zIndex: '1',
            transform: 'translate(50%, -50%)',
        },

        '&::before': {
            content: 'attr(data-header)',
            fontSize: 20,
            fontWeight: 'bold',
            lineHeight: '2',
            letterSpacing: '0.8px',
            top: '45%',

            whiteSpace: 'nowrap',

            '@media (max-width: 767px)': {
                fontSize: 14,
                top: '42%',
                lineHeight: 2.86,
                letterSpacing: '0.56px',
            },
        },

        '&::after': {
            content: 'attr(data-subheader)',
            fontSize: 16,
            fontWeight: 'normal',
            lineHeight: 1.75,
            letterSpacing: '0.64px',
            top: '57%',
            width: 415,
            textAlign: 'center',

            '@media (max-width: 767px)': {
                fontSize: 14,
                lineHeight: 1.57,
                width: 343,
                letterSpacing: '0.56px',
                top: '60%',
            },
        },
    },
    imgOpacity: {
        opacity: '0.3',
        width: '100%',
    },
}))
